<template>
    <div v-if="hasText || (hasTitle && show_title)" class="container mx-auto flex flex-col gap-3 pagetext-content">
        <h1 v-if="hasTitle && show_title" v-html="title" class="page-title"></h1>
    </div>

    <div v-if="hasCountHeading || (show_description && hasText)"
        class="container mx-auto flex flex-col gap-2 pagetext-content">
        <div v-if="hasCountHeading" class="count-heading mb-3 md:mb-6" v-html="count_heading"></div>

        <ReadMore v-if="show_description && hasText" :text="topText" class="page-description page-description-top"></ReadMore>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ReadMore from 'Components/PageText/ReadMore';

export default {
    name: 'TopText',
    components: {
        ReadMore,
    },
    computed: {
        ...mapGetters('pagetext', ['hasCountHeading']),
        ...mapState('pagetext', ['topText', 'title', 'show_title', 'show_description', 'count_heading']),
        hasText() { return this.topText != ''; },
        hasTitle() { return this.title != ''; }
    },
    mounted() {
    }
}
</script>
